import CheckboxIndeterminateIcon from '@atlaskit/icon/core/checkbox-indeterminate';
import { Inline } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import React, { type FunctionComponent } from 'react';

export interface DatabaseEntryPickerOptionProps {
  label: string;
}

const DatabaseValuePickerOption: FunctionComponent<DatabaseEntryPickerOptionProps> = ({
  label,
}) => {
  return (
    <Inline alignBlock="center" space="space.100">
      <CheckboxIndeterminateIcon label="" color={token('color.icon.accent.teal')} />
      {label}
    </Inline>
  );
};

export default DatabaseValuePickerOption;
